import React from 'react'
import { Route } from 'labguard-cdk'
import Login from './Login'
import Widget from './Widget'
import App from './App'

const Main = () => {
  return (
    <Route>
      <Route path="/login" component={Login} breadcrumb={{ i18n: 'WEB_LOGIN' }} />
      <Route path="/widget" component={Widget} breadcrumb={{ i18n: 'WEB_CHANNELS' }} />
      <Route component={App} />
    </Route>
  )
}

export default Main
